import '../styles/Footer.css';

export function Footer(){
  return(
    <footer className="footer">
      Web desarrollada por Cristian Becerra
    </footer>
  );
}